module.exports = __webpack_public_path__ + "static/insta-fbcd91b1a20ad95e65ca696390519dd1.svg";